import { z } from 'zod';

/**
 * A `pms_tag` item in FLAT form, as returned by `GET /api/meta/list?basecode=
 * pms_tag`. Verified against devdb (2026-07): the default projection omits
 * `tag_category`/`frequency` — they must be requested explicitly via
 * `request.fields` — and both are currently null on ~100% of live rows. The
 * frontend degrades to "Non catégorisé" / frequency-less ordering until the
 * backend populates them (see docs/Design_ Visuel UI_UX/word-detail-rework-plan.md §4).
 */
export const tahitiTagSchema = z.object({
  id: z.union([z.string(), z.number()]).optional(),
  guid: z.string().optional(),
  title: z.string().nullish(),
  frequency: z.union([z.string(), z.number()]).nullish(),
  tag_category: z.string().nullish(),
});
export type TahitiTag = z.infer<typeof tahitiTagSchema>;
